export default __webpack_public_path__ + "static/koi-fish-wax-42d2050eeca063f27aff6cf1f417b04c.png";